import { Box, Typography } from "@mui/material";

const STEP_LABELS: Record<string, string> = {
  get_user_profile: "Loading profile...",
  get_talent_insights: "Reading insights...",
  search_events: "Searching events...",
  search_talent: "Scouting players...",
  search_coaches: "Finding coaches...",
  search_scouts: "Finding scouts...",
  search_agents: "Finding agents...",
  search_challenges: "Finding challenges...",
  search_services: "Searching programs...",
  search_jobs: "Searching jobs...",
  compare_profiles: "Comparing...",
  build_campaign_audience: "Building audience...",
  draft_campaign_creative: "Drafting creative...",
  generate_training_plan: "Creating training plan...",
  generate_nutrition_plan: "Creating nutrition plan...",
  generate_team_plan: "Building team session...",
  summarize_notes: "Summarizing...",
  narrate_results: "Writing your answer...",
  start_talent_report_session: "Starting talent report...",
  fallback_response: "Processing...",
};

const ProgressBar = ({ progress, currentStep }: { progress: number; currentStep?: string }) => {
  const stepLabel = currentStep ? STEP_LABELS[currentStep] || currentStep.replace(/_/g, " ") + "..." : "Starting...";

  return (
    <Box sx={styles.container}>
      <Box sx={styles.bar}>
        <Box sx={{ ...styles.fill, width: `${Math.max(5, progress)}%` }} />
      </Box>
      <Box sx={styles.label}>
        <Typography sx={styles.step}>{stepLabel}</Typography>
        <Typography sx={styles.pct}>{progress}%</Typography>
      </Box>
    </Box>
  );
};

export default ProgressBar;

const styles = {
  container: { mb: "16px", pl: "42px", animation: "ginoSlideUp 0.3s ease forwards", "@keyframes ginoSlideUp": { from: { opacity: 0, transform: "translateY(12px)" }, to: { opacity: 1, transform: "translateY(0)" } } },
  bar: { height: 6, background: "#f3f4f6", borderRadius: "9999px", overflow: "hidden", mb: "6px" },
  fill: { height: "100%", background: "linear-gradient(90deg, #106048, #22d3ee, #106048)", backgroundSize: "200% 100%", borderRadius: "9999px", transition: "width 0.4s ease", animation: "ginoShimmer 2s linear infinite", "@keyframes ginoShimmer": { "0%": { backgroundPosition: "200% center" }, "100%": { backgroundPosition: "-200% center" } } },
  label: { display: "flex", justifyContent: "space-between", fontSize: 12, fontFamily: "Montserrat" },
  step: { fontWeight: 600, color: "#106048", fontSize: 12, fontFamily: "Montserrat" },
  pct: { color: "#6b7280", fontSize: 12, fontFamily: "Montserrat" },
};
